import React from 'react'
import { Button, CircularProgress, Typography } from '@material-ui/core'
import { Locale } from '../Locale'
import { MockIntegrationPanel } from '../components/MockIntegrationPanel'
import { useTenant } from '../context/TenantContext'

export function TenantSettingsTab() {
    const { tenantId, details, reload } = useTenant()

    return (
        <>
            <div className="superadmin-toolbar">
                <Button variant="contained" color="primary" size="small" onClick={reload}>
                    Reload tenant
                </Button>
            </div>

            <div className="superadmin-card">
                <Typography variant="subtitle1" gutterBottom>
                    Locations
                </Typography>
                <Locale tenant={details} />
            </div>

            <MockIntegrationPanel tenantId={tenantId} />

            <div className="superadmin-card">
                <Typography variant="subtitle1" gutterBottom>
                    Tenant Record
                </Typography>
                {!details ? (
                    <CircularProgress size={24} />
                ) : (
                    <pre style={{ fontSize: 13, overflow: 'auto', maxHeight: 500 }}>
                        {JSON.stringify(details, null, 2)}
                    </pre>
                )}
            </div>
        </>
    )
}
